// Scraper service configuration
export const SCRAPER_CONFIG = {
  // Python scraper service URL (for admin operations)
  BATCH_URL: 'https://docket-scraper-daily-f9c4eb3ce49c.herokuapp.com',

  // Backend service URL (for case data)
  BACKEND_URL: '', // Empty means same origin

  // API endpoints
  ENDPOINTS: {
    // Health check
    HEALTH: '/health',

    // Year+prefix-specific scraping (Redis-based)
    YEAR_PREFIX_START: (year_prefix) =>
      `/scraping/year-prefix/${year_prefix}/start`,
    YEAR_PREFIX_START_TAIL: (year_prefix) =>
      `/scraping/year-prefix/${year_prefix}/start-tail`,
    YEAR_PREFIX_START_FULL: (year_prefix) =>
      `/scraping/year-prefix/${year_prefix}/start-full`,
    YEAR_PREFIX_START_PROCEEDINGS: (year_prefix) =>
      `/scraping/year-prefix/${year_prefix}/start-proceedings`,
    YEAR_PREFIX_STATUS: (year_prefix) =>
      `/scraping/year-prefix/${year_prefix}/status`,
    YEAR_PREFIX_CLEAR: (year_prefix) =>
      `/scraping/year-prefix/${year_prefix}/clear`,

    // Legacy prefix endpoints (for backward compatibility)
    PREFIX_START: (prefix) => `/scraping/prefix/${prefix}/start`,
    PREFIX_STATUS: (prefix) => `/scraping/prefix/${prefix}/status`,
    PREFIX_CLEAR: (prefix) => `/scraping/prefix/${prefix}/clear`,
    PREFIX_POPULATE: (prefix) => `/scraping/prefix/${prefix}/populate`,

    // List available prefixes
    PREFIXES: '/scraping/prefixes',

    // Stop all scraping
    STOP_ALL: '/scraping/stop',

    // Cyclic scraping (all prefixes)
    CYCLIC_START: '/scraping/cyclic/start',
    CYCLIC_STOP: '/scraping/cyclic/stop',
    CYCLIC_STATUS: '/scraping/cyclic/status',
    CYCLIC_PREFIXES: '/scraping/cyclic/prefixes',

    // Case summary data (from case_summary.json)
    CASE_SUMMARY: '/scraping/raw-data/summary',
    REGENERATE_SUMMARY: '/scraping/raw-data/regenerate-summary',
    REGENERATE_STATUS: '/scraping/raw-data/regenerate-status',

    // Data processing endpoints
    // PROCESS_FILE endpoint removed - processing now handled by merge service
    PROCESSING_STATUS: '/data-processing/status',

    // Case data (through backend)
    CASE_DATA: '/api/cases'
  }
};

// Helper function to get full URL for scraper endpoints
export const getScraperUrl = (endpoint) => {
  return `${SCRAPER_CONFIG.BATCH_URL}${endpoint}`;
};

// Helper function to get full URL for backend endpoints
export const getBackendUrl = (endpoint) => {
  return `${SCRAPER_CONFIG.BACKEND_URL}${endpoint}`;
};
